import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { ERROR_COLOR, SUCCESS_COLOR } from '../../theme';

const CounterValue = styled.span`
  &.success {
    color: ${SUCCESS_COLOR}
  }
  &.error {
    color: ${ERROR_COLOR}
  }
`;

const TextareaCounter = ({ value, minLength }) => (
  <>
    <CounterValue className={value.length >= minLength ? 'success' : 'error'}>
      {value.length}
      {' '}
      caractère(s)
    </CounterValue>
    {` (minimum ${minLength})`}
  </>
);

TextareaCounter.propTypes = {
  value: PropTypes.string.isRequired,
  minLength: PropTypes.number.isRequired,
};

export { TextareaCounter };
